import * as type from '../constants/assessment';

// GET STATUS
export function getStatus(token) {
    return {
        token,
        type: type.GET_STATUS,
    };
}

export function getStatusSuccess(status) {
    return {
        status,
        type: type.GET_STATUS_SUCCESS,
    };
}

export function getStatusFailure(error) {
    return {
        error,
        type: type.GET_STATUS_FAIL,
    };
}

// GET INTRO CONTENT
export function getIntroContent() {
    return {
        type: type.GET_INTRO_CONTENT,
    };
}

export function getIntroContentSuccess(content) {
    return {
        content,
        type: type.GET_INTRO_CONTENT_SUCCESS,
    };
}

export function getIntroContentFailure(error) {
    return {
        error,
        type: type.GET_INTRO_CONTENT_FAIL,
    };
}

export function setAssessmentStatus(assessmentStatus) {
    return {
        assessmentStatus,
        type: type.SET_ASSESSMENT_STATUS,
    };
}

export function getAssessmentReportLinks(clientId, assessmentId, assessmentTakerId) {
    return {
        clientId,
        assessmentId,
        assessmentTakerId,
        type: type.GET_ASSESSMENT_REPORT_LINKS,
    };
}

export function getAssessmentReportLinksSuccess(reportLinks) {
    return {
        reportLinks,
        type: type.GET_ASSESSMENT_REPORT_LINKS_SUCCESS,
    };
}

export function getAssessmentReportLinksFailure(error) {
    return {
        error,
        type: type.GET_ASSESSMENT_REPORT_LINKS_FAIL,
    };
}


// RESEND INSTRUCTION
export function resendAssessmentInstructions(clientId, assessmentId) {
    return {
        clientId,
        assessmentId,
        type: type.RESEND_ASSESSMENT_INSTRUCTIONS,
    };
}

export function resendAssessmentInstructionsSuccess() {
    return {
        type: type.RESEND_ASSESSMENT_INSTRUCTIONS_SUCCESS,
    };
}

export function resendAssessmentInstructionsFailure(error) {
    return {
        error,
        type: type.RESEND_ASSESSMENT_INSTRUCTIONS_FAIL,
    };
}

// ORDER REPORTS
export function orderAssessmentReports(values, actions, assessmentId, submit) {
    return {
        assessmentId,
        values,
        actions,
        submit,
        type: type.ORDER_ASSESSMENT_REPORTS,
    };
}

export function orderAssessmentReportsSuccess() {
    return {
        type: type.ORDER_ASSESSMENT_REPORTS_SUCCESS,
    };
}

export function orderAssessmentReportsFailure(error) {
    return {
        error,
        type: type.ORDER_ASSESSMENT_REPORTS_FAIL,
    };
}


// CANCEL_ASSESSMENT_REPORTS
export function cancelAssessmentReports(status, clientId, assessmentId) {
    return {
        clientId,
        assessmentId,
        status,
        type: type.CANCEL_ASSESSMENT_REPORTS,
    };
}

export function cancelStatusSuccess() {
    return {
        type: type.CANCEL_ASSESSMENT_STATUS_SUCCESS,
    };
}

export function cancelStatusFail(error) {
    return {
        error,
        type: type.CANCEL_ASSESSMENT_STATUS_FAIL,
    };
}


// GET ASSESSMENT
export function getEditAssessment(assessmentTakerId, assessmentId) {
    return {
        assessmentTakerId,
        assessmentId,
        type: type.GET_EDIT_ASSESSMENT,
    };
}

export function getAssessmentSuccess(assessment) {
    return {
        assessment,
        type: type.GET_ASSESSMENT_SUCCESS,
    };
}


export function getAssessmentFailure(error) {
    return {
        error,
        type: type.GET_ASSESSMENT_FAIL,
    };
}

// EDIT
export function edit(values, actions, clientId, assessmentId, resetSubmittingState) {
    return {
        type: type.EDIT_ASSESSMENT,
        values,
        actions,
        clientId,
        assessmentId,
        resetSubmittingState,
    };
}

export function editFailure(error) {
    return {
        error,
        type: type.EDIT_ASSESSMENT_FAIL,
    };
}
export function editSuccess() {
    return {
        type: type.EDIT_ASSESSMENT_SUCCESS,
    };
}
